module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/cn/flags_czech_cn.49496517.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/cn/flags_czech_cn.png
// module id = 1095
// module chunks = 16